








































































import { computed, defineComponent, PropType } from "@nuxtjs/composition-api";
import { checkHttpLink, changeImage, isMobile } from "~/helpers";

interface Banner {
  category?: number;
  url?: string;
  link?: string;
  label?: string;
  type_banner?: string;
  mobile_url?: string;
}

export default defineComponent({
  name: "BannerList",
  components: {},
  props: {
    imageBanner: {
      type: Array as PropType<Banner[]>,
      required: true,
    },

    classBanner: {
      type: String,
      default: "",
    },
    classChild: {
      type: String,
      default: "banner-slide__item",
    },
    showArrows: {
      type: Boolean,
      default: true,
    },
    lazyLoad: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const firstMobileBannerUrl = computed(() => {
      if (isMobile && props.imageBanner && props.imageBanner.length > 0) {
        return changeImage(props.imageBanner[0]?.mobile_url) || "";
      }
      return "";
    });
    return { checkHttpLink, changeImage, firstMobileBannerUrl };
  },

  head() {
    return {
      link: this.firstMobileBannerUrl
        ? [{ rel: "preload", as: "image", href: this.firstMobileBannerUrl }]
        : [],
    };
  },
});
